<template>
<div>
  <b>{{ __('Shopping cart') }}</b>
  <coupon-code />

  <br>

  <div class="checkout-summary-row">
    <b>HeadQ</b>
    <b
      :class="{
        'discount-price' : headQDiscountedPrice !== 0
      }"
      >
        {{ displayCurrency(headQPrice) }}
    </b>
  </div>

  <transition name="slide-fade">
    <div class="checkout-summary-row discount-label" v-if="headQDiscountedPrice !== 0">
      <span>{{__('Discount')}}</span>
      <span>-{{ displayCurrency(headQPrice - headQDiscountedPrice) }}</span>
    </div>
  </transition>

  <transition name="slide-fade">
    <div class="checkout-summary-row discount-label" v-if="headQDiscountedPrice !== 0">
      <b>{{__('Your price')}}</b>
      <b>{{ displayCurrency(headQDiscountedPrice) }}</b>
    </div>
  </transition>
  <div class="checkout-summary-row">
    <span>{{__('Quantity')}}</span>
    <span>{{ quantity }} {{__('pcs')}}</span>
  </div>

  <br><br>

  <div class="checkout-summary-row">
    <b style="font-size: 24px;">{{__('Total')}}</b>
    <b style="font-size: 24px;">{{ displayCurrency(total) }}</b>
  </div>

  <legal-accept v-model="hasAcceptedTermsAndConditions" />

  <el-button margin-top
    :disabled="disabledButton"
    :tooltip="buttonTooltip"
    @click="purchase"
    style="height: 50px; font-size: 18px; text-align: center; align-content: center; font-weight: 700; margin-top: 20px; justify-content: center; width: 100%;"
    >
    {{__('Buy')}}
  </el-button>

</div>
</template>
<script>
import CouponCode from './CouponCode.vue'
import { mapGetters } from 'vuex'
import LegalAccept from '@/components/orderPage/LegalAccept.vue'

export default {
  components: { CouponCode, LegalAccept },
  data () {
    return {
      hasAcceptedTermsAndConditions: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'couponCode',
      'quantity',
      'shippingPrice',
      'headQDiscountedPrice',
      'headQPrice'
    ]),
    subTotal () {
      if (this.headQDiscountedPrice === 0) {
        return this.headQPrice * this.quantity
      }

      return this.headQDiscountedPrice * this.quantity
    },
    total () {
      return this.subTotal + this.shippingPrice
    },
    disabledButton () {
      return this.disabled || !this.hasAcceptedTermsAndConditions
    },
    buttonTooltip () {
      if (this.disabled) {
        return this.__('Please fill in all fields')
      }

      if (!this.hasAcceptedTermsAndConditions) {
        return this.__('You need to accept the terms and conditions')
      }

      return ''
    }
  },
  methods: {
    displayCurrency (value) {
      return `${value} kr`
    },
    purchase () {
      this.$emit('purchase', {
        total: this.total,
        discount: this.headQDiscountedPrice,
        couponCode: this.couponCode
      })
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  @discount-color: #3DA98E;

  .discount-label {
    color: @discount-color;
  }

  .discount-price {
    text-decoration: line-through;
  }

  .checkout-summary-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: none;
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-10px);
    opacity: 0;
  }
</style>
